<template>
  <div class="flashKillbox" :class="{ inApp: $root.$data.isApp }">
    <common-title titleName="活动列表" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <div v-if="allTpyeList.length" class="flashKill">
      <div class="typeNav">
        <van-tabs
          :ellipsis="false"
          title-active-color="#FF6C02"
          color="#FF6C02"
          line-width="22.5px"
          line-height="2.5px"
          v-model="activeName"
          swipeable
          @click="typeChanage"
          :class="isAllowClick ? '' : 'noClick'"
        >
          <van-tab
            v-for="(pages, index) in typeList"
            :key="index"
            :name="pages.id"
            :title="pages.name"
          ></van-tab>
        </van-tabs>
      </div>
      <div class="flashNavBg">
        <img v-if="showOnly" class="acbg" :src="onlyOneBg" alt="" />
        <img v-if="!showOnly" class="acbg" :src="nvaIndex == 0 ? startingBg : nostartBg" alt="" />
        <div class="flashNav" :class="showOnly ? 'showOnly' : ''">
          <div
            v-for="(t, i) in navList"
            :key="i"
            :class="[i == nvaIndex ? 'active' : '']"
            @click="changeNav(t.id, i)"
          >
            {{ t.tit }}
          </div>
        </div>
      </div>

      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        :offset="60"
        @load="onLoad"
      >
        <ul class="courseList">
          <li v-for="(item, keys) in courseInfoData" :key="keys">
            <StartPromot v-if="nvaIndex == 0" :item="item" :key="keys" />
            <NostartPromot v-if="nvaIndex == 1" :item="item" :key="keys" />
          </li>
        </ul>
      </van-list>
    </div>
    <EmptyData v-else :emptyName="'noEvaluation'" />
  </div>
</template>

<script>
import { getTypeaAllApi, getTypePromotionApi } from '@/api/activity';
import StartPromot from './components/startPromot/startPromot.vue';
import NostartPromot from './components/nostartPromot/nostartPromot.vue';
import CommonTitle from '@/components/header/CommonTitle.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import {deepCopy} from "@/utils/tools";

export default {
  components: {
    CommonTitle,
    StartPromot,
    NostartPromot,
    EmptyData,
  },
  props: {},
  data() {
    return {
      nvaIndex: 0, //抢购中 即将进行
      activeName: 0,
      typeList: [],
      courseInfoData: [],
      navList: [],
      isAllowClick: true, //防连点
      showOnly: false, //只有一个活动（抢购中，即将开始）
      loading: false,
      finished: false,
      severTime: 0,
      startingBg: require('@/assets/img/activity/seconDkill/startingbg.png'),
      nostartBg: require('@/assets/img/activity/seconDkill/nostartbg.png'),
      onlyOneBg: require('@/assets/img/activity/seconDkill/onlyOnebg.png'),
      allTpyeList: [],
      pagesTotal: 0,
      pagesObj: {
        promotionTypeId: null,
        status: 1,
        pageNum: 1,
        pageSize: 100, //此处因为不用做分页 所以设置的值比较大
        endPoint: this.$root.$data.isApp ? 2 : 4,
      },
    };
  },

  computed: {},
  created() {
    this.getTypeList();
    document.getElementsByClassName('app')[0].style.height = 'auto'
  },

  mounted() {},

  methods: {
    onLoad() {
      let that = this;
      console.log('onLoad1');
      that.getPromotionList();
    },

    //顶部分类切换
    typeChanage(name) {
      if (this.isAllowClick) {
        this.activeName = name;
        let currentType = this.allTpyeList.filter((item) => item.id === name);
        this.currentStatus(currentType);
      }
    },

    //抢购中/即将开始切换
    changeNav(curIdx, i) {
      if (this.isAllowClick) {
        this.isAllowClick = false;
        this.courseInfoData = [];
        this.nvaIndex = i;
        if (!this.activeName) {
          //兼容第一次加载
          this.pagesObj['promotionTypeId'] = this.allTpyeList[0].id;
        } else {
          this.pagesObj['promotionTypeId'] = this.activeName;
        }
        this.pagesObj['status'] = curIdx;
        this.pagesObj['pageNum'] = 1;
        this.getPromotionList();
      }
    },

    // 获取分类列表
    async getTypeList() {
      const res = await getTypeaAllApi();
      if (res.code === 0) {
        this.typeList = res.data;
        this.pagesObj['promotionTypeId'] = res.data[0].id;
        this.allTpyeList = res.data;
        let currentType = [res.data[0]];
        this.currentStatus(currentType);
      }
    },

    //查询当前下的活动状态
    currentStatus(status) {
      const { notStartCount, doingCount } = status[0];
      if (notStartCount == 0 || doingCount == 0) {
        if (notStartCount == 0 && doingCount > 0) {
          this.navList = [{ id: 1, tit: '抢购中' }];
          this.changeNav(1, 0);
        }
        if (notStartCount > 0 && doingCount == 0) {
          this.navList = [{ id: 2, tit: '即将开始' }];
          this.changeNav(2, 1);
        }
        this.showOnly = true;
      } else {
        this.navList = [
          { id: 1, tit: '抢购中' },
          { id: 2, tit: '即将开始' },
        ];
        this.changeNav(1, 0);
        this.showOnly = false;
      }
    },

    // 促销列表
    async getPromotionList() {
      this.loading = true;
      this.finished = false;
      const { code, data, currentTime } = await getTypePromotionApi(this.pagesObj);
      if (code === 0) {
        this.isAllowClick = true;
        this.severTime = currentTime;
        let realData = data.data;
        if (realData?.length) {
          this.getMajorList(realData);
          this.pagesTotal = data.total;
          this.pagesObj['pageNum'] += 1;
          this.loading = false;
          if (this.pagesTotal === this.courseInfoData.length) {
            this.finished = true;
          }
        } else {
          this.loading = false;
          this.finished = true;
        }
      }
    },

    // 查询课程卡片信息
    async getMajorList(dataList) {
      const resCourse = this.resetProductData(dataList || []);
      this.courseInfoData = [...this.courseInfoData, ...resCourse];
    },
    // 自定义数据格式
    resetProductData(courseList) {
      courseList.forEach((item) => {
        const copyItem = deepCopy(item)
        const {
          productDiscountRespVO,
          teacherRespVOS,
          realSales,
          initialSales,
          startTime,
          sellPrice,
        } = item.homePageProductWebRespVO;
        Object.assign(item.homePageProductWebRespVO, {
          isArk: 1,
          severTime: this.severTime,
          salesVolume: Number(realSales) + Number(initialSales),
          courseBeginTime: startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map((teacher) => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount &&
          productDiscountRespVO?.couponDiscount &&
          sellPrice > 0 &&
          !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item.homePageProductWebRespVO, {
            promotionLabel: 4,
            originalPrice: sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item.homePageProductWebRespVO, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: (
              Number(productDiscountRespVO.discountMinPrice) +
              Number(productDiscountRespVO.discountAmount)
            ).toFixed(2),
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
        if (productDiscountRespVO?.isGroupDiscount) {
          Object.assign(item, {
            promotionLabel: 5,
            originalPrice: copyItem.sellPrice,
            sellPrice: productDiscountRespVO.discountMinPrice,
          });
        }
      });
      return courseList;
    },
  },
};
</script>

<style lang="scss" scoped>
.inApp {
  .flashKill {
    padding-top: 100px;
    .typeNav {
      top: 0;
    }
  }
}
.flashKill {
  padding-top: 200px;
  min-height: 100vh;
  background-color: #ffb43d;

  .typeNav {
    position: fixed;
    top: 100px;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 2;
    width: 100%;
    height: 90px;
    background-color: #fff;
  }

  .flashNavBg {
    position: relative;
    margin-top: 36px;
    margin-bottom: 20px;

    .acbg {
      display: block;
      width: 428px;
      height: 118px;
      margin: 0 auto;
    }
  }

  .flashNav {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin: 0 auto;
    width: 430px;
    height: 120px;
    display: flex;
    align-items: center;

    div {
      width: 50%;
      height: 100%;
      line-height: 134px;
      text-align: center;
      position: relative;
      font-size: 29px;
      font-weight: 400;
      color: #853902;
    }

    .active {
      color: #ffffff;
    }
  }
  .showOnly {
    justify-content: center;
    pointer-events: none;
    div {
      color: #ffffff;
    }
  }
  .noClick {
    pointer-events: none;
  }

  .courseList {
    box-sizing: border-box;
    width: 100%;
    padding: 20px 0;

    li {
      position: relative;
      width: 679px;
      margin: 0 auto;
      margin-bottom: 18px;
      background: $bgWhite;
      border-radius: 32px;
    }
  }
  ::v-deep .van-list__finished-text {
    color: #fff;
  }
}

.inApp {
  padding-top: 0;
}
</style>
